<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="是否已删除 0未删除 1已删除" prop="deleted">
        <el-input v-model="form.deleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="创建人编码" prop="createUser">
        <el-input v-model="form.createUser" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker v-model="form.createTime" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="updateUser">
        <el-input v-model="form.updateUser" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker v-model="form.updateTime" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="会员主键" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入会员主键" v-trim/>
      </el-form-item>
      <el-form-item label="提现金额(单位:分)" prop="amount">
        <el-input v-model="form.amount" placeholder="请输入提现金额(单位:分)" v-trim/>
      </el-form-item>
      <el-form-item label="微信平台交易订单号" prop="wxExternalNo">
        <el-input v-model="form.wxExternalNo" placeholder="请输入微信平台交易订单号" v-trim/>
      </el-form-item>
      <el-form-item label="状态:0=提现申请中:1=提现成功；2=提现失败；" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态:0=提现申请中:1=提现成功；2=提现失败；" v-trim/>
      </el-form-item>
      <el-form-item label="提现完成时间" prop="doneTime">
        <el-date-picker v-model="form.doneTime" value-format="yyyy-MM-dd" placeholder="请输入提现完成时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="完成备注" prop="doneInfo">
        <el-input v-model="form.doneInfo" placeholder="请输入完成备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaWithdrawalOrdersWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        memberId: '',
        amount: '',
        wxExternalNo: '',
        status: '',
        doneTime: '',
        doneInfo: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/withdrawalOrders',
      'field.id': 'id'
    })
  }
}
</script>
